import React, { useEffect, useState } from "react";
import axios from "axios";
import { Activity, ArrowLeft, Lock } from "lucide-react";
import ReportGroups from "@/components/ReportGroups";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ReportPage() {
  const parts = window.location.pathname.split("/").filter(Boolean); // ["report","AAPL"]
  const ticker = (parts[1] || "").toUpperCase();
  const qs = new URLSearchParams(window.location.search);
  const [period, setPeriod] = useState(qs.get("period") === "annual" ? "annual" : "quarterly");
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const token = localStorage.getItem("auth_token");

  useEffect(() => {
    if (!token) { setLoading(false); return; }
    setLoading(true);
    setError(null);
    axios.get(`${API}/stock/${ticker}/report`, { params: { period }, headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setReport(r.data))
      .catch((e) => setError(e.response?.data?.detail || "Report unavailable."))
      .finally(() => setLoading(false));
  }, [ticker, period, token]);

  return (
    <div className="min-h-screen bg-[#EDF3F6] px-4 py-6 md:px-10">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
          <div className="flex items-center gap-3">
            <img src="/qls-logo-v3.png" alt="QLS" className="h-9 w-9 object-contain rounded-md bg-white p-0.5 ring-1 ring-[#D2E0E6]" />
            <div>
              <h1 className="text-2xl font-bold mono text-[#0B2830]" data-testid="report-ticker">{ticker}</h1>
              <div className="text-xs text-[#7C949C]">Financial report &middot; last {period === "quarterly" ? "8 quarters" : "5 fiscal years"}</div>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="inline-flex bg-[#E9F1F4] border border-[#D2E0E6] rounded-md p-0.5">
              {["quarterly", "annual"].map((p) => (
                <button key={p} data-testid={`report-period-${p}`} onClick={() => setPeriod(p)}
                  className={`px-3 py-1 text-xs mono rounded transition-colors ${
                    period === p ? "bg-[#0284C7] text-white" : "text-[#47616B] hover:text-[#0B2830]"}`}>
                  {p === "quarterly" ? "Quarterly" : "Annual"}
                </button>
              ))}
            </div>
            <a href="/" data-testid="report-back-link" className="flex items-center gap-1.5 text-xs text-[#47616B] hover:text-[#0284C7]">
              <ArrowLeft className="w-4 h-4" /> Back to screener
            </a>
          </div>
        </div>

        {!token ? (
          <div className="bg-white border border-[#D2E0E6] rounded-lg p-10 text-center">
            <Lock className="w-8 h-8 text-[#0284C7] mx-auto mb-4" />
            <p className="text-sm text-[#47616B]">Please sign in on the main screener first, then reopen this report.</p>
          </div>
        ) : loading ? (
          <div className="py-24 text-center">
            <Activity className="w-8 h-8 text-[#0284C7] mx-auto mb-4 animate-pulse" />
            <p className="text-sm text-[#47616B]">Loading {ticker} financials&hellip;</p>
          </div>
        ) : error ? (
          <div className="bg-white border border-[#E11D48]/30 rounded-lg p-8 text-center text-[#E11D48] text-sm">{error}</div>
        ) : (
          <ReportGroups report={report} />
        )}
        <p className="text-xs text-[#7C949C] mt-6">For informational purposes only, not investment advice. Data: stockanalysis.com.</p>
      </div>
    </div>
  );
}
